import type { useTrpc } from "@app/vue/providers/TrpcProvider";
import { getRestaurantDayRangeUtc } from "@lemmonhq/blogic";

type TrpcClient = ReturnType<typeof useTrpc>;

type ReservationQueryParams = Record<string, unknown> & {
  date?: Date | string;
  timezone?: string;
};
type ReservationRequestQueryParams = Record<string, unknown>;

const toNumber = (value: unknown) =>
  value == null || value === "" ? undefined : Number(value);

const toStringArray = (value: unknown) => {
  if (value == null) return undefined;
  return Array.isArray(value) ? value.map(String) : [String(value)];
};

export const listReservations = (
  trpc: TrpcClient,
  filters: ReservationQueryParams = {},
) => {
  const { date, timezone, ...rest } = filters;
  const query =
    date && !rest.date_from && !rest.date_to
      ? {
          ...rest,
          ...getRestaurantDayRangeUtc(date, timezone || "UTC"),
        }
      : rest;

  return trpc.reservations.list.query({
    status: toStringArray(query.status),
    customer_name: query.customer_name as string | undefined,
    party_name: query.party_name as string | undefined,
    date_from: query.date_from as string | undefined,
    date_to: query.date_to as string | undefined,
    party_size: query.party_size as string | number | undefined,
    table_id: query.table_id as string | number | undefined,
    user_id: query.user_id as string | number | undefined,
    sort: (query.sort as any) ?? "time",
    order: (query.order as any) ?? "desc",
    limit: toNumber(query.limit) ?? 50,
    offset: toNumber(query.offset) ?? 0,
  });
};

export const listReservationRequests = (
  trpc: TrpcClient,
  filters: ReservationRequestQueryParams = {},
) =>
  trpc.reservations.listRequests.query({
    status: filters.status as any,
    customer_name: filters.customer_name as string | undefined,
    party_name: filters.party_name as string | undefined,
    date_from: filters.date_from as string | undefined,
    date_to: filters.date_to as string | undefined,
    date_field: (filters.date_field as any) ?? "requested_time",
    party_size: filters.party_size as string | number | undefined,
    sort: (filters.sort as any) ?? "requested_time",
    order: (filters.order as any) ?? "desc",
    limit: toNumber(filters.limit) ?? 50,
    offset: toNumber(filters.offset) ?? 0,
  });
